import gql from 'graphql-tag';

/**
 * Fetch guarantee transactions for a specific contract card.
 */
export const GUARANTEE_TRANSACTIONS_BY_CARD_QUERY = gql`
	query GuaranteeTransactionsByContractCard(
		$contractCardId: Ulid!
		$first: Int
		$after: String
	) {
		guaranteeTransactionsByContractCard(
			contractCardId: $contractCardId
			first: $first
			after: $after
			order: [{ createdAt: DESC }]
		) {
			nodes {
				guaranteeTransactionId
				contractCardId
				facilityId
				guaranteeTransactionTypeId
				grossAmount
				netAmount
				vatAmount
				vatPercentage
				createdAt
				notes
				reversesTransactionId
				replacedCardId
				guaranteeTransactionType {
					guaranteeTransactionTypeId
					name
					involvesCashMovement
					isFiscal
				}
				processedByUser {
					userId
					firstName
					lastName
				}
				reversedByTransaction {
					guaranteeTransactionId
					createdAt
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

/**
 * Fetch guarantee transaction types lookup.
 */
export const GUARANTEE_TRANSACTION_TYPES_QUERY = gql`
	query GuaranteeTransactionTypes {
		guaranteeTransactionTypes {
			guaranteeTransactionTypeId
			name
			involvesCashMovement
			isFiscal
		}
	}
`;

/**
 * Create a guarantee transaction (deposit, return, replacement, transfer).
 */
export const CREATE_GUARANTEE_TRANSACTION_MUTATION = gql`
	mutation CreateGuaranteeTransaction(
		$input: CreateGuaranteeTransactionInput!
	) {
		createGuaranteeTransaction(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

/**
 * Void an existing guarantee transaction.
 */
export const VOID_GUARANTEE_TRANSACTION_MUTATION = gql`
	mutation VoidGuaranteeTransaction($input: VoidGuaranteeTransactionInput!) {
		voidGuaranteeTransaction(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;
